import { getApiBenefits } from "./getApiBenefits";
import { getApiBenefitsOpenEnrollmentAvailable } from "./getApiBenefitsOpenEnrollmentAvailable";
import { postApiBenefits } from "./postApiBenefits";
import { postApiBenefitsCalculateRates } from "./postApiBenefitsCalculateRates";

export function benefitsController() {
  return {
    getApiBenefits,
    postApiBenefits,
    postApiBenefitsCalculateRates,
    getApiBenefitsOpenEnrollmentAvailable,
  };
}
